// THIS HAD TO BE CREATED AS THE BE FILTERS WONT WORK AS IT GOES THROUGH STRIPE
import { DataTableProviderFilterStateValue } from '@/components/common/DataTableProviderFilters/types';
import { DataTableSortData } from '@/components/ui/DataTable/types';
import { FILTERS } from '@/constants/policyFilters';
import { BillingHistoryInterface } from '@interfaces/Membership.interface';

export const PAYMENT_STATUS = {
  open: 'OPEN',
  paid: 'PAID'
} as const;

export const handleFilters = (
  filters: { [key: string]: unknown } = {},
  resData: BillingHistoryInterface[]
) => {
  return resData.filter((data) => {
    const { invoice_number, created_at_start, created_at_end, status } =
      filters;
    // CHECK INVOICE NUMBER
    if (invoice_number && !data.number.includes(invoice_number as string)) {
      return false;
    }
    // CHECK DATES:
    const dateToCheck = new Date(data.created);
    dateToCheck.setHours(0, 0, 0, 0);

    if (created_at_start && created_at_end) {
      const startDate = new Date(created_at_start as string);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(created_at_end as string);
      endDate.setHours(23, 59, 59, 999);

      if (!(dateToCheck >= startDate && dateToCheck <= endDate)) {
        return false;
      }
    } else {
      if (created_at_start) {
        const startDate = new Date(created_at_start as string);
        startDate.setHours(0, 0, 0, 0);
        if (dateToCheck < startDate) {
          return false;
        }
      }
      if (created_at_end) {
        const endDate = new Date(created_at_end as string);
        endDate.setHours(23, 59, 59, 999);
        if (dateToCheck > endDate) {
          return false;
        }
      }
    }
    if (status !== undefined) {
      if (
        typeof status === 'string' &&
        data.status.toUpperCase() !== status.toUpperCase()
      ) {
        return false;
      }
    }

    // Additional filters can be added here for specific use cases.

    return true;
  });
};

export const readBasicsFromUrl = (): {
  search?: string;
  page?: number;
  perPage?: number;
  sort?: DataTableSortData;
} => {
  const params = new URLSearchParams(window.location.search);
  const search = params.get('search') ?? undefined;
  const page = params.get('page') ? Number(params.get('page')) : undefined;
  const perPage = params.get('perPage') ? Number(params.get('perPage')) : undefined;
  const sort = params.get('sort')
    ? (JSON.parse(params.get('sort') as string) as DataTableSortData)
    : undefined;
  return { search, page, perPage, sort };
};

export const readFiltersFromUrlToMap = () => {
  const params = new URLSearchParams(window.location.search);
  const map = new Map<string, DataTableProviderFilterStateValue>();
  FILTERS.forEach((f) => {
    const v = params.get(f.filterKey);
    if (v !== null && v !== '') {
      const value = f.type === 'date_range' ? v.split(',') : v;
      map.set(f.filterKey, {
        value,
        label: Array.isArray(value) ? value : String(value),
        item: { label: f.label, filterKey: f.filterKey, type: f.type }
      });
    }
  });
  return map;
};

export const readFiltersFromUrlToObject = () => {
  const params = new URLSearchParams(window.location.search);
  const obj: Record<string, unknown> = {};
  FILTERS.forEach((f) => {
    const v = params.get(f.filterKey);
    if (v !== null && v !== '') {
      obj[f.filterKey] = f.type === 'date_range' ? v.split(',') : v;
    }
  });
  return obj;
};

export const writeListStateToUrl = (args: {
  searchTerm?: string;
  page?: number;
  perPage?: number;
  sort?: DataTableSortData;
  filters?: Record<string, unknown>;
}) => {
  const params = new URLSearchParams(window.location.search);

  // core
  if (args.searchTerm) params.set('search', args.searchTerm);
  else params.delete('search');

  if (args.sort) params.set('sort', JSON.stringify(args.sort));
  else params.delete('sort');

  if (args.page) params.set('page', String(args.page));
  else params.delete('page');

  if (args.perPage) params.set('perPage', String(args.perPage));
  else params.delete('perPage');

  // filters
  const defined = new Set<string>(FILTERS.map((f) => f.filterKey));
  Array.from(params.keys()).forEach((k) => {
    if (defined.has(k) && !(args.filters && k in args.filters)) {
      params.delete(k);
    }
  });
  if (args.filters) {
    Object.entries(args.filters).forEach(([k, v]) => {
      if (v === '' || v === undefined || v === null) {
        params.delete(k);
      } else if (Array.isArray(v)) {
        params.set(k, v.join(','));
      } else {
        params.set(k, String(v));
      }
    });
  }

  const newUrl = params.toString()
    ? `${window.location.pathname}?${params.toString()}`
    : window.location.pathname;

  window.history.replaceState({}, document.title, newUrl);
};
